import React from 'react';
import styled from 'styled-components';

import { Button } from '../../ui-library/buttons';
import NewsletterSubscriptionModal from './NewsletterSubscriptionModal';
import { Space } from '../../ui-library/space';
import useModalState from '../../utils/useModalState';
import { trackJoinNewsletterClick } from '../tracking/discovery.tracking';

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
const StyledTitle = styled.div`
  color: ${(props) => props.theme.colors.white};

  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: 24px;
  letter-spacing: 0.5px;
  text-align: left;

  opacity: 0.5;
`;
const NewsletterSubscriptionWidget = () => {
  const [Modal, isOpen, show, hide] = useModalState(
    NewsletterSubscriptionModal
  );

  const handleJoinNow = () => {
    trackJoinNewsletterClick();
    show();
  };

  return (
    <StyledWrapper>
      <Modal isOpen={isOpen} onHide={hide} />

      <StyledTitle>
        Join our newsletter to stay up to date on features and releases
      </StyledTitle>
      <Space size={4} />
      <Button isDark onClick={handleJoinNow}>
        Join now
      </Button>
    </StyledWrapper>
  );
};

export default NewsletterSubscriptionWidget;


// This implementation has UI for input text box. Once we confirm the implementation of 'Join Now' form, this can be removed
//
// import React from 'react';
// import styled from 'styled-components';
// import { Button } from '../../ui-library/buttons';
// import { Space } from '../../ui-library/space';
// import useModalState from '../../utils/useModalState';
// import NewsletterSubscriptionModal from './NewsletterSubscriptionModal';
// import send from './Send.svg';

// const StyledWrapper = styled.div`
//   display: flex;
//   flex-direction: column;

//   margin-top: 10px;
// `;
// const StyledTitle = styled.div`
//   color: #636156;

//   font-family: Roboto;
//   font-size: 14px;
//   font-style: normal;
//   font-weight: 300;
//   line-height: 24px;
//   letter-spacing: 0.5px;
//   text-align: left;

//   opacity: 0.5;
// `;
// const StyledInputWrapper = styled.div`
//   background: #f1f0e0;
//   height: 48px;
//   padding: 12px;
//   margin-top: 12px;
//   display: flex;

//   /* grey */
//   border: 1px solid #c9c8be;

//   /* Form Input Inner Shadow */
//   box-shadow: inset 0px 1px 5px rgba(0, 0, 0, 0.15);
//   border-radius: 7px;
// `;
// const StyledInput = styled.input`
//   border: 0;
//   background-color: rgb(0, 0, 0, 0);
//   flex-grow: 1;

//   font-family: Roboto;
//   font-style: normal;
//   font-weight: 300;
//   font-size: 14px;
//   line-height: 24px;

//   /* secondary-dark */
//   color: #1e1c11;

//   :focus {
//     outline: none;
//   }
// `;
// const StyledIcon = styled.img`
//   flex-shrink: 0;
//   max-width: 23px;
//   max-height: 19px;
//   padding-top: 1px;
// `;
// const NewsletterSubscriptionWidget = () => {
//   return (
//     <StyledWrapper>
//       <StyledTitle>
//         Join our newsletter to stay up to date on features and releases
//       </StyledTitle>
//       <StyledInputWrapper>
//         <StyledInput type='text' placeholder='Enter your email' />
//         <StyledIcon src={send} />
//       </StyledInputWrapper>
//     </StyledWrapper>
//   );
// };

// export default NewsletterSubscriptionWidget;
